import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import pick from 'lodash/pick';
import findIndex from 'lodash/findIndex';

// import { Link } from 'react-router-dom';
import {
  Modal,
  ModalBody,
  Button
} from 'reactstrap';
import ModalHeader from '../reactstrap/ModalHeader';

import ProjectForm from './form';
import ProjectMembers from './members';
import ProjectMembersForm from './membersForm';
import ProjectDomains from './domains';
import ProjectDomainsForm from './domainsForm';

import { 
  listProjects,
  updateProjectSuccess,
  deleteProjectSuccess,
  addMemberSuccess,
  addDomainSuccess
} from '../../actions';

import { Project, Member, Domain } from '../../api'

import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faTrashAlt from '@fortawesome/fontawesome-pro-light/faTrashAlt';


const mapStateToProps = state => ({ projects: state.projects, isLoading: state.loaders.projects });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ listProjects, updateProjectSuccess, deleteProjectSuccess, addMemberSuccess, addDomainSuccess }, dispatch)
};


const modalPropKeys = Object.keys(Modal.propTypes);

class EditProjectModal extends Component {
  
  constructor(props) {
    super(props);
    this.deleteProject = this.deleteProject.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    // this.onMemberAddSuccess = this.onMemberAddSuccess.bind(this);
    
    this.state = {
      ...this.state,
      isDeleting: false,
    };
  }
  componentWillMount(nextProps) {
    // this.props.listProjects();
  }
  
  onSuccess(res) {
    const { updateProjectSuccess, toggle } = this.props; 
    updateProjectSuccess(res);
    toggle();
  }
  
  deleteProject(e) {
    if (e && e.preventDefault)
      e.preventDefault();
    
    if (!window.confirm(`Are you sure you want to delete this project with all its links and team?!`)){
      return;
    }
    
    const { projectId, deleteProjectSuccess, toggle } = this.props;
    const stopLoading = () => this.setState({isDeleting:false});
    
    this.setState({isDeleting:true});
    Project.destroy({id:projectId}).then(deleteProjectSuccess).then( ()=> {
      stopLoading();
      toggle();
    }, stopLoading);
  }
  
  render() {
    const { projectId, toggle, updateProjectSuccess, addMemberSuccess, addDomainSuccess, projects, ...otherProps } = this.props;
    
    const projectIdx = findIndex(projects, {id: projectId})
    const project = projects[projectIdx]
    
    const modalProps = pick(otherProps, modalPropKeys);
    
    return (project && project.is_owner ? 
      <Modal {...modalProps} centered={true}>
        <ModalHeader toggle={toggle}>Edit Project</ModalHeader>
        <ModalBody>
          <ProjectForm initialValues={project} onSubmit={Project.update} onSuccess={this.onSuccess} />
          
          {true && <React.Fragment>
          <h3 className="mt-4">Custom domains</h3>
          <ProjectDomains project={project} />
          <ProjectDomainsForm project={project} onSubmit={Domain.create} onSuccess={addDomainSuccess} />
          </React.Fragment>}
          
          <h3 className="mt-4">Team members</h3>
          <ProjectMembers project={project} />
          <ProjectMembersForm project={project} onSubmit={Member.create} onSuccess={addMemberSuccess} />
          
          <div className="text-center mt-4">
            <Button color="link" onClick={this.deleteProject}><FA icon={faTrashAlt} /> delete this project and all the links</Button>
          </div>
          
        </ModalBody>
      </Modal>
      : null);
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(EditProjectModal);


// WEBPACK FOOTER //
// ./src/components/Projects/editModal.js